var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.$store.state.user.tipo == 2)?_c('professor'):_c('escola')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }